// extracted by mini-css-extract-plugin
module.exports = {"root":"PeerGroupMeetingCombobox_root__hiVS6","footer":"PeerGroupMeetingCombobox_footer__rPyV2"};